import React from "react"
import {Link} from "react-router-dom"
import {getPathBack} from "../functions"

export class CheckingCollectionsClass extends React.Component {

    render() {

        const {auth} = this.props
        console.log(auth)

        return (
            <>
                <div className={'container m-auto w-100'}>
                    <div className={'mb-2 col d-flex flex-nowrap justify-content-start'}>
                        {<Link id={'to-back'}
                                               to={getPathBack()}
                                               type={'button'}
                                               className={'col col-md-2 col-lg-2 col-sm-3 col-2 btn btn-info m-1 fs-5 p-sm-1 p-2 d-flex align-items-center justify-content-center fw-bold'}>
                            <i className={'fa-solid fa-arrow-left'}/>
                        </Link>}
                    </div>
                </div>
            </>
        )
    }
}